import { TP_Building } from "../../automationObjects/Plants/Buildings/P_Building";
import { useGetMatchQuery } from "../../services/objects";
import { modelId } from '../../automationObjects/Plants/Buildings/P_Building/types'

interface useGetBuildingOutput {
    item: TP_Building | undefined,
    error: any,
    isLoading: boolean,
    isSuccess: boolean
}

//get the parent building of an digitaltwin
function useGetBuilding(objectId: string, resourceGroupId: string): useGetBuildingOutput {
    const { data, error, isLoading, isSuccess } = useGetMatchQuery({ objectId: objectId, resourceGroupId: resourceGroupId, modelId: modelId, relationship: 'ContainedIn' });

    return {
        item: (data && data.length > 0) ? data[0] : undefined,
        error: error,
        isLoading: isLoading,
        isSuccess: isSuccess,
    }
}

export default useGetBuilding